export default __webpack_public_path__ + "static/media/Seal of Yog.30460533.jpg";